import { skipToken } from "@reduxjs/toolkit/query";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { useAllMinimalPlaybooksQuery } from "../../api/entities/playbook.js";

/**
 * Resolves the effective playbook ID for a learning journey.
 * If a playbook_id is explicitly configured, uses that.
 * Otherwise, defaults to the oldest (first) playbook in the company.
 */
export function useLearningJourneyPlaybookId(
  configuredPlaybookId: PlaybookId | null,
): {
  playbookId: PlaybookId | null;
  isLoading: boolean;
} {
  const { data: playbooks, isLoading } = useAllMinimalPlaybooksQuery(
    configuredPlaybookId !== null
      ? skipToken
      : { shouldExcludeTeammateAgentPlaybooks: true },
  );

  if (configuredPlaybookId) {
    return { playbookId: configuredPlaybookId, isLoading: false };
  }

  return {
    playbookId: playbooks?.at(0)?.id ?? null,
    isLoading,
  };
}
